import React from 'react';
import ReactDOM from "react-dom";
import {
    AiOutlineShoppingCart,
    AiFillCloseCircle,
    AiFillMinusCircle,
} from "react-icons/ai";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const CartComponentModal = (props) => {
    const navigate = useNavigate();
    const checkoutHandle = () => {
        props.handleOrderFailed();
        navigate("/checkout");
    };
    const onQuantityAdd = (productid, name, size, price, quantity) => {
        props.addItemsToCart(productid, name, size, price, quantity);
    };
    const handleOnRemove = (productid, name, size, price, quantity) => {
        props.removeFromCart(productid, name, size, price, quantity);
    };
    const onclearCartbtn = () => {
        props.clearCart();
    };
    return ReactDOM.createPortal(
        <div

            className="bg-teal-200   h-full absolute top-0 right-0  py-10 w-[250px] "
        >
            <div className="font-semibold text-xl text-center pt-4 pl-2">
                Shopping Cart
            </div>
            <span className="absolute top-5 right-2 text-2xl text-teal-600">
                <AiFillCloseCircle
                    className="cursor-pointer"
                    onClick={() => props.onClick(false)}

                />
            </span>
            <ol className="mt-4 list-decimal m-5">
                {props.cart.map((cart) => (
                    <li className="flex mb-2">
                        <div className="w-2/3 text-sm">
                            {cart.name} ({cart.size})
                        </div>
                        <div className="w-1/3 text-sm flex content-center justify-center">
                            <span className="text-xl mr-1 text-teal-500">
                                <BsFillPlusCircleFill
                                    onClick={() =>
                                        onQuantityAdd(
                                            cart.productid,
                                            cart.name,
                                            cart.size,
                                            cart.price,
                                            cart.quantity
                                        )
                                    }
                                    className="cursor-pointer"
                                ></BsFillPlusCircleFill>
                            </span>
                            {cart.quantity}
                            <span>
                                <AiFillMinusCircle
                                    onClick={() =>
                                        handleOnRemove(
                                            cart.productid,
                                            cart.name,
                                            cart.size,
                                            cart.price,
                                            cart.quantity
                                        )
                                    }
                                    className="cursor-pointer text-xl ml-1 text-teal-500"
                                ></AiFillMinusCircle>
                            </span>
                        </div>
                        <div></div>
                    </li>
                ))}

                <div className="mt-16 font-bold">Subtotal: ₹{props.subtotal}</div>
                <div className="flex">
                    <button
                        onClick={() => checkoutHandle()}
                        disabled={props.cart.length === 0}
                        className="mx-auto mt-2 text-white bg-teal-500 disabled:bg-teal-300 border-0 py-1 px-2 focus:outline-none hover:bg-teal-600 rounded text-sm"
                    >
                        Checkout
                    </button>
                    <button
                        disabled={props.cart.length === 0}
                        className=" mx-auto mt-2  text-white bg-teal-500 disabled:bg-teal-300 border-0 py-1 px-2 focus:outline-none hover:bg-teal-600 rounded text-sm"
                        onClick={() => onclearCartbtn()}
                    >
                        Clear Cart
                    </button>
                </div>
            </ol>
        </div>,
        document.getElementById("portal")
    )
}

export default CartComponentModal